import DrmKeySystem from '../../Shared/Constants/DrmKeySystem';

const MIME_TYPE = 'video/mp4';

/**
 * Creates a FairPlay session for the provided video element, using
 * the provided key and content ID.
 *
 * Returns the session.
 */

const createSession = (videoElement: any, key: Uint8Array, contentId: string): any => {
    const keySystem = new (window as any).WebKitMediaKeys(DrmKeySystem.FAIRPLAY);

    videoElement.webkitSetMediaKeys(keySystem);

    const session = videoElement.webkitKeys.createSession(MIME_TYPE, key);

    session.contentId = contentId;

    return session;
};

export default createSession;